// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"navigation_item_NavigationItem__22dnA","Active":"navigation_item_Active__gS7FT"};